import { render, staticRenderFns } from "./getPlan.vue?vue&type=template&id=10306458&scoped=true"
import script from "./getPlan.vue?vue&type=script&lang=js"
export * from "./getPlan.vue?vue&type=script&lang=js"
import style0 from "./getPlan.vue?vue&type=style&index=0&id=10306458&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10306458",
  null
  
)

export default component.exports